import 'ui-select/dist/select.css';
import angular from 'angular';
import formly from 'angular-formly';
// import formlyBootstrap from './formly-bootstrap';
import formlyBootstrap from 'angular-formly-templates-bootstrap';
import ngSanitize from 'angular-sanitize';
import ngMessages from 'angular-messages';
import uiSelect from 'ui-select';
import uiMask from 'angular-ui-mask';
import { datemask } from './datemask.js';

// templates
import fieldsetTpl from './templates/fieldset.html';
import rowTpl from './templates/row.html';
import divTpl from './templates/div.html';
import horizontalLabelTpl from './templates/horizontalLabel.html';
import horizontalCheckboxTpl from './templates/horizontalCheckbox.html';
import validationTpl from './templates/validation.html';
import errorMessagesTpl from './templates/errorMessages.html';
import uiSelectTpl from './templates/ui-select.html';
import uiSelectAsyncTpl from './templates/ui-select-async.html';
import feedTpl from './templates/feed.html';

const forms = angular.module('forms', [ngSanitize, ngMessages, formly, formlyBootstrap, uiMask, uiSelect]);

function setWrappers(formlyConfig) {
    // formlyConfig.setWrapper({
    //     name: 'validation',
    //     templateUrl: 'app/blocks/formly/templates/validation.html'
    // });

    formlyConfig.setWrapper({
        name: 'row',
        templateUrl: rowTpl
    });

    formlyConfig.setWrapper({
        name: 'div',
        templateUrl: divTpl
    });

    formlyConfig.setWrapper({
        name: 'fieldset',
        templateUrl: fieldsetTpl
    });

    formlyConfig.setWrapper({
        name: 'horizontalBootstrapLabel',
        templateUrl: horizontalLabelTpl
    });

    formlyConfig.setWrapper({
        name: 'horizontalBootstrapCheckbox',
        templateUrl: horizontalCheckboxTpl
    });
}

configFunc.$inject = ['formlyConfigProvider'];
function configFunc(formlyConfigProvider) {
    formlyConfigProvider.setWrapper({
        name: 'validation',
        types: [
            'input',
            'hInput',
            'maskedInput',
            'textarea',
            'select',
            'typeahead',
            'datepicker',
            'hDatepicker',
            'hSelect',
            'hTextarea',
            'huiSelect',
            'uiSelect',
            'uiSelectAsync',
            'huiSelectAsync'
        ],
        templateUrl: validationTpl
    });
}

runFunc.$inject = ['formlyConfig'];
function runFunc(formlyConfig) {
    formlyConfig.extras.errorExistsAndShouldBeVisibleExpression = '!fc.$pristine || form.$submitted';

    setWrappers(formlyConfig);

    formlyConfig.setType({
        name: 'hInput',
        extends: 'input',
        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
    });

    formlyConfig.setType({
        name: 'hCheckbox',
        extends: 'checkbox',
        wrapper: ['horizontalBootstrapCheckbox', 'bootstrapHasError']
    });

    formlyConfig.setType({
        name: 'hRadio',
        extends: 'radio',
        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
    });

    formlyConfig.setType({
        name: 'hSelect',
        extends: 'select',
        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
    });

    formlyConfig.setType({
        name: 'hTextarea',
        extends: 'textarea',
        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
    });

    formlyConfig.setType({
        name: 'typeahead',
        extends: 'input',
        defaultOptions: {
            ngModelAttrs: {
                uibTypeahead: {
                    attribute: 'typeahead'
                },
                typeaheadOnSelect: {
                    attribute: 'typeahead-on-select'
                },
                typeaheadWaitMs: {
                    attribute: 'typeahead-wait-ms'
                },
                typeaheadEditable: {
                    attribute: 'typeahead-editable'
                }
            },

            ngModelElAttrs: {
                autocomplete: 'off'
            }
        }
    });

    formlyConfig.setType({
        name: 'hTypeahead',
        extends: 'typeahead',
        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
    });

    formlyConfig.setType({
        name: 'maskedInput',
        extends: 'input',
        defaultOptions: {
            ngModelAttrs: {
                mask: {
                    attribute: 'ui-mask'
                },
                maskPlaceholder: {
                    attribute: 'ui-mask-placeholder'
                }
            },
            templateOptions: {
                maskPlaceholder: ''
            }
        }
    });

    formlyConfig.setType({
        name: 'datepicker',
        extends: 'maskedInput',
        defaultOptions: {
            templateOptions: {
                maskPlaceholder: 'DD.MM.GGGG',
                mask: '99.99.9999'
            },
            ngModelElAttrs: {
                datemask: ''
            }
        }
    });

    formlyConfig.setType({
        name: 'timepicker',
        extends: 'maskedInput',
        defaultOptions: {
            templateOptions: {
                maskPlaceholder: 'HH:MM',
                mask: '99:99'
            },
            ngModelElAttrs: {
                'model-view-value': 'true'
            }
        }
    });

    formlyConfig.setType({
        name: 'datetimepicker',
        extends: 'maskedInput',
        defaultOptions: {
            templateOptions: {
                maskPlaceholder: 'DD.MM.GGGG hh:mm',
                mask: '99.99.9999 99:99'
            },
            ngModelElAttrs: {
                datemask: '',
                format: 'datetime'
            }
        }
    });

    formlyConfig.setType({
        name: 'hTimepicker',
        extends: 'timepicker',
        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
    });

    formlyConfig.setType({
        name: 'hDatepicker',
        extends: 'datepicker',
        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
    });

    formlyConfig.setType({
        name: 'hDatetimepicker',
        extends: 'datetimepicker',
        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
    });

    formlyConfig.setType({
        name: 'uiSelect',
        extends: 'select',
        templateUrl: uiSelectTpl
    });

    formlyConfig.setType({
        name: 'huiSelect',
        extends: 'uiSelect',
        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
    });

    formlyConfig.setType({
        name: 'uiSelectAsync',
        extends: 'select',
        templateUrl: uiSelectAsyncTpl,
        defaultOptions: {
            templateOptions: {
                optionsAttr: 'bs-options',
                ngOptions: 'option[to.valueProp] as option in to.options',
                options: [],
                refreshDelay: 700
            }
        }
    });

    formlyConfig.setType({
        name: 'huiSelectAsync',
        extends: 'uiSelectAsync',
        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
    });
}

forms.config(configFunc);
forms.run(runFunc);

forms.directive('datemask', datemask);

export { forms };



// WEBPACK FOOTER //
// ./app/components/common/forms/forms.js